import { render, staticRenderFns } from "./LoginPageTitle.vue?vue&type=template&id=3170fbef&scoped=true&"
import script from "./LoginPageTitle.vue?vue&type=script&lang=js&"
export * from "./LoginPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageTitle.vue?vue&type=style&index=0&id=3170fbef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3170fbef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3170fbef')) {
      api.createRecord('3170fbef', component.options)
    } else {
      api.reload('3170fbef', component.options)
    }
    module.hot.accept("./LoginPageTitle.vue?vue&type=template&id=3170fbef&scoped=true&", function () {
      api.rerender('3170fbef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signIn/common/Text/LoginPageTitle.vue"
export default component.exports